import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ApplicationLinkContainer from '../shared/applicationLink/applicationLinkContainer';
import { useStateContext } from '../../modules/stateContext';
import { isExUk } from '../../utilities/isExUk';
import { footerItemsExUk } from './footerLinksExUk';
import { footerItemsUk } from './footerLinksUk';

const BbcFooterLinks = ({ target }) => {
    const stateContext = useStateContext();
    const footerItems = isExUk(stateContext.location)
        ? footerItemsExUk
        : footerItemsUk;
    return (
        <ul>
            {footerItems.map(item => (
                <li key={item.id}>
                    <ApplicationLinkContainer
                        href={item.href}
                        target={target}
                        external
                        tertiary
                    >
                        <FormattedMessage id={item.id} />
                    </ApplicationLinkContainer>
                </li>
            ))}
        </ul>
    );
};

BbcFooterLinks.displayName = 'BbcFooterLinks';

BbcFooterLinks.propTypes = {
    target: PropTypes.string,
};

export default BbcFooterLinks;
